export default class AgentLogoffAction {
  constructor(agentId) {
    this.agentId = agentId;
    this.exten = '';
    this.action = 'AgentLogoffAction';
    this.client = `agent-${agentId}`;

    console.log('Enviando informações de logoff:', this);
  }
}
